import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService } from '../services/auth';

export default function PrivateRoute({ children, adminOnly = false }) {
    const location = useLocation();

    if (!AuthService.isLoggedIn()) {
        return <Navigate to="/giris-yap" state={{ from: location }} replace />;
    }

    if (adminOnly && !AuthService.isAdmin()) {
        return <Navigate to="/" replace />;
    }

    return children;
}
